// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"ac968d7f","425":"d717283e","602":"cbcc2eb2","654":"c802b3c4","766":"d84efdb6","778":"f2863718","823":"4885150e","879":"e6f07f4c","912":"e895f97d","938":"ff97fc94","979":"4acf76bd"}[chunkId] + ".chunk.js";
};